import { FormSectionHandler } from '../entity.handler';
import { AssetResponse, AssetUpdateRequest, IdName, AssetParameters } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, ComboField, EntityUtils } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    assetType?: IdName;
    color?: string;
    tags?: string[];
    costCentre?: IdName;
    groups?: IdName[];
    assetTag?: IdName;
    parameters?: AssetParameters;
}

export class AssetDetailsMiniSectionHandler implements FormSectionHandler<AssetResponse, EditorValues> {

    type = 'form';
    icon = ICONS.asset;
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private colors = ['blue', 'lightblue', 'green', 'olive', 'orange', 'pink', 'purple', 'red', 'teal', 'yellow', 'white', 'gray'];
    private properties = ['name', 'color'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSET.DETAILS.${key}`, values);
    }

    applyUpdate(entity: AssetResponse, payload: AssetUpdateRequest): Promise<AssetResponse> {
        return this.admin.applyUpdate(api => api.entities.updateAsset(entity.id, payload));
    }

    mapEntityToEditor(entity: AssetResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields<EditorValues>(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: AssetUpdateRequest, values: EditorValues): Promise<AssetUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    async getFields(entity: AssetResponse): Promise<FormBuilderField[]> {
        const fields = [
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ComboField('color', this.translate('FIELDS.COLOR'), true, this.colors.map(x => ({ key: x, value: this.translate(`COLORS.${x.toUpperCase()}`) })).sort((a, b) => a.value.localeCompare(b.value))),
        ].filter(x => x);
        return EntityUtils.prepareBulk(!entity, ['color'], fields);
    }

   
}
